import FlexBox from '@/atomic-components/FlexBox';

import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useState } from 'react';
import DiscountBadge from '@/assets/offers/DiscountBadgeIcon';
import { IOffers } from '@/components/ProductDisplayPage/model';
import SideArrowIcon from '../../../../../assets/pdp/sideArrowIcon.svg';
import OfferDrawerComponent from './offerDrawer';
import TimeCountdown from '@/components/TimeCoundown';

const offerTileStyles = {
	width: '100%',
	background: 'linear-gradient(90deg, #FFF5B7 0%, #FFFBDB 100%)',
	position: 'relative',
	border: '1px dashed #EBEBEB',
	borderRadius: '4px',
	marginRight: '5px',
	alignItems: 'start',
	'&::before': {
		backgroundColor: '#FFFFFF',
		borderRadius: '50px',
		content: `''`,
		height: '17px',
		width: '17px',
		left: '-10px',
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
	},
	'&::after': {
		backgroundColor: '#FFFFFF',
		borderRadius: '50px',
		content: `''`,
		width: '17px',
		height: '17px',
		top: '50%',
		transform: 'translateY(-50%)',
		right: '-10px',
		position: 'absolute',
	},
};

type ApplyOfferTile = {
	offers: IOffers[];
	addEvents: (eventType: string, expiryText?: string) => void;
};

function ApplyOfferTile(props: ApplyOfferTile) {
	const [codeCopied, setCodeCopied] = useState('');
	const [selectedOfferToView, setSelectedOfferToView] = useState<IOffers>();

	function offerClicked(offer: IOffers) {
		setSelectedOfferToView(offer);
	}

	function closeOfferDetailsDrawer() {
		setSelectedOfferToView(undefined);
	}

	return (
		<FlexBox direction='column'>
			{props.offers?.map((offer, index) => {
				return (
					<Box
						key={index}
						sx={{ width: '100%', margin: '16px 0', cursor: 'pointer' }}
						onClick={() => offerClicked(offer)}
					>
						<FlexBox justifyContent='flex-end'>
							<Box sx={{ zIndex: 2, position: 'relative' }}>
								<TimeCountdown
									endDate={offer?.endDate}
									setOfferTimeOver={() => null}
								/>
							</Box>
						</FlexBox>
						<FlexBox
							direction='column'
							sx={{
								...offerTileStyles,
								alignItem: 'start',
								justifyContent: 'start',
								width: '380px',
							}}
						>
							<Box
								sx={{
									width: '100%',
									padding: '16px',
									backgroundSize: 'contain',
									backgroundPositionX: 'right',
									backgroundRepeat: 'no-repeat',
									backgroundImage: `url(https://assets.furlenco.com/s3-furlenco-images/grogu/OfferIcon.svg)`,
								}}
							>
								<FlexBox
									sx={{
										borderBottom: `1px dashed ${getColor('Yellow -1')}`,
										alignItems: 'start',
										justifyContent: 'spaceBetween',
									}}
								>
									<FlexBox sx={{ alignItems: 'start' }}>
										<Box sx={{ height: '48px', width: '48px' }}>
											<DiscountBadge height={48} width={48} />
										</Box>
										<FlexBox>
											<FlexBox
												direction='column'
												sx={{ paddingLeft: '8px', alignItems: 'start' }}
											>
												<LencoTypography
													sx={{
														...getStyle('H10_Medium'),
														paddingBottom: '4px',
														color: getColor('Gray 0'),
													}}
												>
													{offer?.header}
												</LencoTypography>
												<LencoTypography
													sx={{
														...getStyle('Small_Regular'),
														color: getColor('Gray -1'),
														paddingBottom: '8px',
													}}
												>
													{offer?.description}
												</LencoTypography>
												<LencoTypography
													sx={{
														...getStyle('Tiny_Medium'),
														color: getColor('Danger -1'),
														paddingBottom: '16px',
													}}
												>
													{offer?.expiryText}
												</LencoTypography>
											</FlexBox>
											<Box
												sx={{ cursor: 'pointer' }}
												onClick={() => offerClicked(offer)}
											>
												<SideArrowIcon />
											</Box>
										</FlexBox>
									</FlexBox>
								</FlexBox>
								<FlexBox
									sx={{
										width: '100%',
										marginTop: '12px',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<LencoTypography
										sx={{
											...getStyle('Small_Medium'),
											color: getColor('Yellow +3'),
										}}
									>
										Coupon code : {offer?.code}
									</LencoTypography>
									{codeCopied === offer.code ? (
										<FlexBox
											sx={{
												backgroundColor: getColor('Success +1'),
												width: '100px',
												borderRadius: '16px',
												justifyContent: 'center',
												alignItems: 'center',
												height: '32px',
											}}
										>
											<LencoTypography
												sx={{ ...getStyle('Tiny_Medium'), color: '#FFFFFF' }}
											>
												Code copied !
											</LencoTypography>
										</FlexBox>
									) : (
										<FlexBox
											sx={{
												backgroundColor: '#FFFFFF',
												width: '100px',
												borderRadius: '16px',
												justifyContent: 'center',
												alignItems: 'center',
												cursor: 'pointer',
												height: '32px',
											}}
											onClick={(e) => {
												e.stopPropagation();
												navigator.clipboard.writeText(offer?.code);
												props.addEvents(
													'PDP Offers and Discounts Copied',
													offer.expiryText
												);
												setCodeCopied(offer?.code);
											}}
										>
											<LencoTypography
												sx={{ ...getStyle('Tiny_Medium'), color: '#222222' }}
											>
												COPY CODE
											</LencoTypography>
										</FlexBox>
									)}
								</FlexBox>
							</Box>
						</FlexBox>
					</Box>
				);
			})}
			<OfferDrawerComponent
				offer={selectedOfferToView as IOffers}
				open={!!selectedOfferToView}
				onClose={closeOfferDetailsDrawer}
				addEvents={(eventType: string, expiryText?: string) =>
					props.addEvents(eventType, expiryText)
				}
				codeCopied={selectedOfferToView?.code == codeCopied}
				setCodeCopied={(value: any) => setCodeCopied(value)}
			/>
		</FlexBox>
	);
}

export default ApplyOfferTile;
